"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var _default = exports.default = function _default() {
  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    size: 64,
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserOutlined, null)
  }), /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    size: "large",
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserOutlined, null)
  }), /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserOutlined, null)
  }), /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    size: "small",
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserOutlined, null)
  })), /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    shape: "square",
    size: 64,
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserOutlined, null)
  }), /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    shape: "square",
    size: "large",
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserOutlined, null)
  }), /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    shape: "square",
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserOutlined, null)
  }), /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    shape: "square",
    size: "small",
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserOutlined, null)
  })));
};